import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'
import '../../css/table-responsive.css'

export default class extends Component {

    render() {
        const { Title, loading, error } = this.props
        const heading = Title || 'Products with Missing Image'

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{heading}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        const dataToDisplay = Array.isArray(this.props.data) ? this.props.data : []

        return (
            <div className='card'>
                <div className='card-body'>
                    <div className='col-sm-12 text-center my-3'>
                        <h5 className='mb-0'>
                            {heading}
                            {dataToDisplay.length > 0 &&
                                <span className='badge rounded-pill text-bg-danger ms-2'>{dataToDisplay.length}</span>
                            }
                        </h5>
                    </div>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-sm-12'>
                            {dataToDisplay.length === 0 ? (
                                <p className='text-center text-muted my-4 mb-0'>No products are missing an image.</p>
                            ) : (
                                <div className="tableFixHeadSmall">
                                    <table className='table align-middle table-hover text-center'>
                                        <thead className='table-dark'>
                                            <tr>
                                                <th>No</th>
                                                <th>Item Code</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataToDisplay.map((item, k) => (
                                                <tr key={item.itemCode || k}>
                                                    <td className='text-start'>{k + 1}</td>
                                                    <td className='text-start'>{item.itemCode}</td>
                                                    <td className='text-start'>{item.ItemCodeDesc}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
